import { request } from "@/client/api/client";
import { getStoredUserId } from "@/client/auth/userStorage";
import type { AnnouncementPayload } from "@/shared/announcement";

const buildEditorHeaders = () => {
  const userId = getStoredUserId();
  return userId ? { "new-api-user": userId } : undefined;
};

export const fetchAnnouncement = async (): Promise<AnnouncementPayload> => {
  return request<AnnouncementPayload>({
    endpoint: "/api/workers-proxy/announcement",
    resolveEndpoint: false,
    includeAuth: false,
    cache: "no-store",
    headers: buildEditorHeaders(),
  });
};

export interface UpdateAnnouncementInput {
  enabled: boolean;
  title: string;
  message: string;
  severity: AnnouncementPayload["severity"];
  updatedBy?: string;
}

export const updateAnnouncement = async (
  payload: UpdateAnnouncementInput
): Promise<AnnouncementPayload> => {
  return request<AnnouncementPayload>({
    method: "PUT",
    endpoint: "/api/workers-proxy/announcement",
    resolveEndpoint: false,
    includeAuth: false,
    body: payload,
    headers: buildEditorHeaders(),
  });
};
